import { ServerTime } from '@spotify-internal/transport/lib/server_time';
import { HarmonyController } from './_internal/controller';
import { PlayerAPIClient } from './_internal/connect_service/client';
export function createControllerForClient(client, options = {}) {
    const transport = client.getPublicTransport();
    const version = client.getVersionDescriptor().tagged;
    const playerClient = PlayerAPIClient.create({
        autoregister: 'autoregister' in options ? options.autoregister : true,
        descriptor: client.getClientDescriptor(),
        transport,
    });
    return HarmonyController.create({
        client,
        playerClient,
        version,
        serverTime: ServerTime.create(transport),
        decorateTrackWindow: typeof options.decorateTrackWindow === 'boolean'
            ? options.decorateTrackWindow
            : true,
        disableProgress: options.disableProgress,
    });
}
//# sourceMappingURL=controller.js.map